<div :id="id"
     class="m-base-calendar"
     :class="{'m--is-years-months-view': isYearsMonthsView,
              'm--is-max-row': isMaxRow}">
    <nav class="m-base-calendar__header"
         :class="{'m--is-select-mode': !isDaysView}">
        <strong v-if="isButtonToogleViewDisabled">{{ currentMonthName }} {{ currentYear }}</strong>
        <m-link v-else
                class="m-base-calendar__current-month-and-year"
                :mode="modeLinkCurrentMonthAndYear"
                @click.stop="onToogleView"
                aria-live="polite"
                ref="currentDate">{{ currentMonthName }} {{ currentYear }}</m-link>
        <transition name="m--is">
            <div v-if="isDaysView"
                 class="m-base-calendar__nav-buttons">
                <m-icon-button class="m-base-calendar__previous"
                               @click.stop="onMonthPrevious()"
                               :disabled="isMinMonth"
                               icon-name="m-svg__chevron--left"
                               icon-size="16px"
                               ref="previousMonth"
                               skin="link">{{ previousMonthLabel }}</m-icon-button>
                <m-icon-button class="m-base-calendar__next"
                               @click.stop="onMonthNext()"
                               :disabled="isMaxMonth"
                               icon-name="m-svg__chevron--right"
                               icon-size="16px"
                               ref="nextMonth"
                               skin="link">{{ nextMonthLabel }}</m-icon-button>
            </div>
        </transition>
    </nav>
    <div class="m-base-calendar__body"
         aria-live="polite"
         ref="body">
        <transition name="m--is">
            <div v-if="isDaysView"
                 class="m-base-calendar__days-view">
                <div class="m-base-calendar__week">
                    <span v-for="(w, weekdayIndex) in weekdaysLabels"
                          :key="weekdayIndex"
                          class="m-base-calendar__weekday">{{ w }}</span>
                </div>
                <div class="m-base-calendar__days-grid">
                    <m-calendar-button v-for="(d, dayIndex) in days"
                                       :key="dayIndex"
                                       class="m-base-calendar__day"
                                       :class="{ 'm--is-highlighted': d.isHighlighted,
                                             'm--is-in-future': isDateInFuture(d),
                                             'm--is-inside-range': isInsideRange(d),
                                             'm--is-other-month': d.isInPreviousMonth || d.isInNextMonth,
                                             'm--is-selection-start': isSelectionStart(d),
                                             'm--is-selection-end': isSelectionEnd(d)}"
                                       :disabled="d.isDisabled || hideDay(d)"
                                       :selected="d.isSelected"
                                       :today="d.isToday"
                                       @click="onDaySelect(d)"
                                       @keyup="onKeyUp($event, d)"
                                       @mouseenter="onDayMouseEnter(d)"
                                       @mouseleave="onDayMouseLeave(d)"
                                       :ref="buildRef(mBaseCalendarView.DAYS, currentYear, currentMonth + 1, d.day)">
                        <span class="m-base-calendar__day-content"
                              :class="{ 'm--is-hidden': hideDay(d) }">{{ d.day }}</span>
                    </m-calendar-button>
                </div>
            </div>
        </transition>
        <transition name="m--is"
                    @enter="scrollToCurrentYear">
            <div v-if="isYearsMonthsView"
                 class="m-base-calendar__years-months-view"
                 ref="yearsMonthsView">
                <template v-for="(yM, yearsMonthsIndex) in yearsMonths">
                    <h2 class="m-base-calendar__year-title"
                        :class="{'m--is-current': yM.year.isCurrent}"
                        :data-current-year="yM.year.isCurrent">{{yM.year.year}}</h2>
                    <div class="m-base-calendar__month-list">
                        <m-calendar-button v-for="(m, monthIndex) in yM.months"
                                           :key="monthIndex"
                                           :disabled="m.isDisabled"
                                           @click="onYearMonthSelect(yM.year, m)"
                                           @keyup="onYearMonthSelectKeyup($event, yM.year.year, m)"
                                           :selected="m.isCurrent"
                                           :ref="buildRef(mBaseCalendarView.YEARS_MONTHS, yM.year.year, m.month + 1)">{{ monthIndexToShortName(m.month) }}</m-calendar-button>
                    </div>
                </template>
            </div>
        </transition>
    </div>
</div>
